import { render, staticRenderFns } from "./InfoHeader.vue?vue&type=template&id=65573867&scoped=true"
import script from "./InfoHeader.vue?vue&type=script&lang=js"
export * from "./InfoHeader.vue?vue&type=script&lang=js"
import style0 from "./InfoHeader.vue?vue&type=style&index=0&id=65573867&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65573867",
  null
  
)

export default component.exports